import { render, staticRenderFns } from "./elementOverlay.vue?vue&type=template&id=25a503ea"
import script from "./elementOverlay.vue?vue&type=script&lang=js"
export * from "./elementOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports